export const ROUTE_PATHS = {
  CHECK: '/check',
  MIMIC: '/mimic',
  ROOT: '/',
  LOGIN: '/user/login',

  USER: '/user',
  USER_LOGIN: '/user/login',
  USER_FORGOT_PASSWORD: '/user/forgotpassword',

  RESET_PASSWORD: '/set-password/:token',

  SSO_CALLBACK: '/sso/callback',

  SUPPORT: '/support',
  SUPPORT_TICKET_DETAILS: '/support/:ticketId',
  SERVICE_REQUESTS: '/service-requests',
  LOCATION_DETAIL: '/locations/:locationId',
  LOCATION_REPORT: '/locations/:locationId/report',
  STUDIO: '/studio',
  TAG_STATISTICS: '/tag-statistics',
  SETTINGS: '/settings',
  COMPONENTS: '/playground',
  PROFILE: '/profile',
  LANGUAGE: '/language',
  WORKSPACE_SETTINGS: '/workspace-settings',
  /** Legacy: booking pages now live under Touchpoints; this URL redirects. */
  BOOKING_PAGES: '/booking-pages',
  BILLINGS: '/billings',
  BILLINGS_DETAILS: '/billings/:billingId',

  // Marketing (lead-generation) reports — /reports/<solution>/<page>, same
  // scheme as the sales reports below. Old bare /reports/* URLs redirect in
  // routes.ts.
  REPORTS: '/reports/marketing/',
  REPORTS_DASHBOARD: '/reports/marketing/overview',
  REPORTS_MARKET_RESEARCH: '/reports/marketing/market-research',
  REPORTS_PERFORMANCE: '/reports/marketing/performance',
  REPORTS_CTA: '/reports/marketing/cta',

  LEAD_GENERATION_CUSTOMERS_ROOT: '/customers/',
  LEAD_GENERATION_CUSTOMERS_LIST: '/customers/list',
  LEAD_GENERATION_CUSTOMERS_SERVICE_REQUESTS: '/customers/requests',

  CONTENT_ROOT: '/content/',
  CONTENT_PROMOTIONS: '/content/promotions',
  CONTENT_IMAGES: '/content/images',
  CONTENT_FILES: '/content/files',
  CONTENT_SETTINGS: '/content/settings',

  ORGANIZATION_ROOT: '/organization/',
  ORGANIZATION_LOCATIONS: '/organization/locations',
  ORGANIZATION_USER: '/organization/users',
  ORGANIZATION_ROLES: '/organization/roles',
  ORGANIZATION_SERVICE_TYPES: '/organization/service-types',
  ORGANIZATION_EXTRA_FIELD_TYPES: '/organization/field-types',
  ORGANIZATION_PRODUCT_GROUPS: '/organization/product-groups',
  ORGANIZATION_DATA_ENTRY_MANAGEMENT: '/organization/data-entry-management',

  USERS_DETAILS: '/users/:agentId',

  // Sales (lead-management) reports. Old /lead-management-reports/* URLs
  // redirect in routes.ts.
  REPORTS_LEAD_MANAGEMENT: '/reports/sales/',
  REPORTS_DASHBOARD_LEAD_MANAGEMENT: '/reports/sales/performance',
  TEAM_PERFORMANCE: '/reports/sales/team',
  GOAL_PLANNING: '/reports/sales/goals',
  REPORTS_FUNNEL_LEAD_MANAGEMENT: '/reports/sales/funnel',
  REPORTS_CALL_BACK_LEAD_MANAGEMENT: '/reports/sales/calls',

  TASKS: '/tasks',
  TASK_DETAILS: '/tasks/:taskId',
  TASK_DETAILS_LEGACY: '/task/:taskId',
  MY_DAY: '/dashboard',
  // Top-level nav item, not a report — it used to live at
  // /reports/sales/overview, which now redirects here.
  TEAM_OVERVIEW: '/sales-cockpit',

  // Touchpoints — everything a customer actually sees: the emails we send, the
  // booking pages they land on, and the design and wording those two share.
  // Old /automations/email-center and /booking-pages URLs redirect in routes.ts.
  TOUCHPOINTS_ROOT: '/touchpoints/',
  EMAIL_CENTER: '/touchpoints/email-center',
  TOUCHPOINTS_BOOKING_PAGES: '/touchpoints/booking-pages',
  TOUCHPOINTS_DESIGN: '/touchpoints/design',
  TOUCHPOINTS_TRANSLATIONS: '/touchpoints/translations',
  TOUCHPOINTS_LEAD_SOURCES: '/touchpoints/lead-sources',

  CRM_ROOT: '/crm/',
  CALENDAR: '/calendar',
  APPOINTMENTS: '/crm/appointments',
  APPOINTMENTS_STANDALONE: '/appointments',
  DOUBLE_BOOKINGS: '/appointments/double-bookings',
  LEADS: '/crm/table',
  LEADS_BOARD: '/crm/board',
  NOTIFICATION_CENTER: '/crm/notifications',
  LEAD_DETAIL: '/lead/:leadId',
  APPOINTMENT_DETAILS: '/appointments/:appointmentId/*',
  CALENDAR_EVENT_DETAILS: '/calendar-events/:calendarEventId/*',

  OPEN_PROPOSALS: '/open-proposals',
  Calls: '/calls',
  TRACKING_DEMO: '/tracking-demo',
  // Agents & Tools (the menu label; the path stays /integrations). Holds the
  // connected apps plus the tools that run on their own — exports and the two
  // automations, which used to be a top-level Automations group. Old
  // /crm/exports and /automations/* URLs redirect in routes.ts.
  INTEGRATIONS: '/integrations',
  INTEGRATIONS_APPS: '/integrations/apps',
  INTEGRATION_DETAILS: '/integrations/apps/:integration_type',
  API_KEYS: '/integrations/api-keys',
  EXPORT_CENTER: '/integrations/exports',
  AUTOMATION_TASK: '/integrations/automated-tasks',
  AUTOMATION_USER: '/integrations/automated-messages',
  OAUTH_CALLBACK: '/oauth/:integration_type/callback',
};
